window.dropdown = () => {
  return {
    show: false,
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
  };
};

// ----------------------------------------------------------------------

let navItems = document.querySelectorAll('.jsNavListItem');
let navToggles = document.querySelectorAll('.jsNavToggle');

navToggles.forEach(btn =>
{
	let parentListItem = btn.parentNode;
	btn.addEventListener('click', () =>
	{
		if (! parentListItem.classList.contains('menuOpen'))
		{
			navItems.forEach(li =>
			{
				li.classList.remove('menuOpen');
			});
		}
		parentListItem.classList.toggle('menuOpen');
	} );
});

// Close menus on ESC keypress
document.addEventListener('keydown', function(event)
{
	if (event.key === 'Escape')
	{
		let openNavItems = document.querySelectorAll('.jsNavListItem.menuOpen');
		let htmlEl = document.documentElement;
		if ( openNavItems.length )
		{
			openNavItems.forEach(navItem =>
			{
				navItem.classList.remove('menuOpen');
			});
		}
		else if (htmlEl.dataset.mainMenuState == 'open')
		{
			htmlEl.dataset.mainMenuState = "closed";
		}
		else
		{
			console.log("No open menus");
		}
	}
});